import React from 'react'

function TrialExpiredFormStyle() {
    return (
        <style jsx="true">
        {`
            .trial-form-container {
                display: flex;
                flex-direction: column;
                padding: 5px;
                height: 100%;
            }

            .form-content-wrapper {
                height: 100%;
            }

            .button-contianer {
                display: flex;
                justify-content: flex-end;
            }
        `}
        </style>
    )
}

export default React.memo(TrialExpiredFormStyle)